const GHL_ORIGINS = [
  "https://api.leadconnectorhq.com",
  "https://link.msgsndr.com",
] as const;

export function ensureGhlPreconnect() {
  if (typeof document === "undefined") return;

  for (const href of GHL_ORIGINS) {
    if (!document.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
      const preconnect = document.createElement("link");
      preconnect.rel = "preconnect";
      preconnect.href = href;
      preconnect.crossOrigin = "anonymous";
      document.head.appendChild(preconnect);
    }

    if (!document.querySelector(`link[rel="dns-prefetch"][href="${href}"]`)) {
      const prefetch = document.createElement("link");
      prefetch.rel = "dns-prefetch";
      prefetch.href = href;
      document.head.appendChild(prefetch);
    }
  }
}

export const ghlPreconnectLinks = [
  { rel: "preconnect" as const, href: GHL_ORIGINS[0], crossOrigin: "anonymous" as const },
  { rel: "preconnect" as const, href: GHL_ORIGINS[1], crossOrigin: "anonymous" as const },
  { rel: "dns-prefetch" as const, href: GHL_ORIGINS[0] },
  { rel: "dns-prefetch" as const, href: GHL_ORIGINS[1] },
];
